import { get, post } from '../request';
import { toPage, type Page } from './types';

/** 站内通知（v1.2 通知中心） */
export interface Notification {
  id: number;
  user_id: number;
  type: string;
  title: string;
  body?: string;
  ref_type?: string;
  ref_id?: string;
  /** 通知强度（info|warning|critical，缺省=info）：critical 驱动高危阻断式弹窗 */
  level?: string;
  read: boolean;
  created_at?: string;
}

export async function listNotifications(q?: { read?: boolean; type?: string; ref_type?: string; page?: number; pageSize?: number }): Promise<Page<Notification>> {
  const params: Record<string, any> = { page: 1, pageSize: 20, ...(q || {}) };
  if (q?.read !== undefined) params.read = String(q.read);
  if (q?.type) params.type = q.type;
  if (q?.ref_type) params.ref_type = q.ref_type;
  return toPage<Notification>(await get('/notifications', params));
}

export function readNotification(id: number) {
  return post(`/notifications/${id}/read`, {});
}

export function readAllNotifications() {
  return post('/notifications/read-all', {});
}

/** GET /notifications/unread-count（当前用户未读数） */
export async function unreadNotificationCount(): Promise<number> {
  const d: any = await get('/notifications/unread-count');
  return Number(d?.unread ?? 0);
}
